const OfferSpendListTableLangKey = [
	'column_id',
	'column_date',
	'column_date_updated',
	'column_amount',
	'column_account_id',
	'column_account',
	'column_account_in_group',
	'column_kt_group',
	'column_offer_id',
	'column_offer',
	'column_scope_id',
	'column_scope',
	'column_history',
	'column_notes'
] as const

type IOfferSpendListTableLangKey = typeof OfferSpendListTableLangKey[number]

export type IOfferSpendListTableLang = {
	offer_spend_list_table: Record<IOfferSpendListTableLangKey, string>
}

const langEntries = OfferSpendListTableLangKey.map(
	(key: IOfferSpendListTableLangKey) => [key, `offer_spend_list_table.${key}`]
)

const langObj: Record<IOfferSpendListTableLangKey, string> = Object.fromEntries(langEntries)

export const OFFER_SPEND_LIST_TABLE_LANG_KEY: IOfferSpendListTableLang = {
	offer_spend_list_table: langObj
}
